<template lang="pug">
  v-card.user-page
    portal(to='toolbar')
      v-toolbar-title User Details / CBR Exams
    .body.inner-scroll
      list(
        :loading="listLoading"
        :list="list"
        :pagination="pagination"
        :headers="headers"
        disable-sorting
        hide-select
        hide-actions
        v-slot="{item}"
        @loadMoreClick="loadListMore"
      )
        td.pl-4.w-50 {{ item.cbr.id }}
        td.pl-4 {{ item.cbr.name }}
        td.px-4.d-flex.justify-end.w-120 {{ item.created | formattedDate }}
</template>

<script>
import {UserTabMixin} from "../mixins/user-tab.mixin";
import {UsersService} from "../core/users-service";

export default {
  mixins: [UserTabMixin],
  data() {
    return {
      headers: [
        { text: 'ID', align: 'left', class: 'pl-4 w-50'},
        { text: 'CBR Name', align: 'left', class: 'pl-4'},
        { text: 'Date', align: 'right', class: 'px-4 w-120' },
      ]
    }
  },
  created() {
    this.svc = new UsersService(this.$auth);
    this.loadFromApi = this.svc.loadUserCbrExams;
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/users-tab-style";
</style>
